import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../data/site";
import { Lines, Reveal } from "../motion";
import { Eyebrow } from "../ui-bits";

export const ServicesIndex = () => {
  return (
    <section className="px-5 py-24 sm:px-10 md:py-36 lg:px-16" data-testid="home-services">
      <div className="grid grid-cols-12 gap-y-8 lg:gap-x-10">
        <div className="col-span-12 lg:col-span-3"><Reveal><Eyebrow n="02">Servizi</Eyebrow></Reveal></div>
        <div className="col-span-12 lg:col-span-9">
          <Lines lines={["Cosa possiamo fare", "per la tua attività."]} className="text-4xl leading-[1.1] sm:text-5xl lg:text-6xl" />
        </div>
      </div>
      <div className="relative mt-16 md:mt-24">
        <ul className="border-t border-ink/15">
          {SERVICES.map((s) => (
            <li key={s.id} className="border-b border-ink/15">
              <Link to={`/servizi#${s.id}`} className="group grid grid-cols-12 items-start gap-y-4 py-10 md:gap-x-6 md:py-14" data-testid={`home-service-${s.id}`}>
                <span className="col-span-2 font-serif text-sm text-teal md:col-span-1">{s.n}</span>
                <img src={s.img} alt="" loading="lazy" className="photo col-span-3 col-start-10 aspect-square w-full object-cover md:hidden" />
                <div className="col-span-12 md:col-span-5">
                  <h3 className="text-3xl leading-tight transition-transform duration-700 ease-out group-hover:translate-x-3 md:text-4xl lg:text-[2.6rem]">{s.title}</h3>
                  <div className="mt-8 hidden aspect-[16/10] w-56 overflow-hidden md:block lg:w-64">
                    <img src={s.img} alt="" loading="lazy" className="photo photo-hover h-full w-full object-cover group-hover:scale-[1.06]" />
                  </div>
                </div>
                <div className="col-span-12 md:col-span-5">
                  <p className="font-serif text-lg leading-snug text-teal md:text-xl">{s.lead}</p>
                  <p className="mt-3 text-sm leading-relaxed text-ink/75 md:text-base">{s.text}</p>
                </div>
                <ArrowUpRight className="col-span-1 hidden justify-self-end text-ink/50 transition-[color,transform] duration-500 group-hover:rotate-45 group-hover:text-teal md:block" strokeWidth={1.2} size={28} aria-hidden="true" />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
